import { Info, StatusCellRenderer } from "./GridFrameworks";

export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 60,
    },
    {
        headerName: "Name",
        field: "Name",
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Email",
        field: "Email",
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Phone",
        field: "PhoneNumber",
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: "City",
        field: "City",
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: "Type",
        field: "Type",
        flex: 1,
        minWidth: 120,
    },
    {
        headerName: "Status",
        field: "Status",
        cellRenderer: StatusCellRenderer,
        width: 120,
    },
];
